import React from "react";
import { Card, CardContent, CardHeader } from "@/components/Card/Card";
import { LifetimeValueByTierData } from "@/modules/stochastic/features/Reports/SCDashboard/api/fetchStochasticDashboardData/types";
import { formatCurrency } from "@/modules/stochastic/features/Reports/SCDashboard/utils/chart";

interface Props {
  initialData?: LifetimeValueByTierData;
}

export const LifetimeValueByTierTable: React.FC<Props> = ({ initialData }) => {
  const chartData = initialData?.chartData ?? [];

  return (
    <Card className="w-full">
      <CardHeader></CardHeader>
      <CardContent className="pb-10">
        <div className="w-full overflow-auto border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm dark:[&::-webkit-scrollbar]:w-2 dark:[&::-webkit-scrollbar]:h-2 dark:[&::-webkit-scrollbar-track]:bg-gray-800 dark:[&::-webkit-scrollbar-thumb]:bg-primary dark:[&::-webkit-scrollbar-thumb]:rounded-full dark:[&::-webkit-scrollbar-corner]:bg-gray-800">
          <table className="w-full caption-bottom text-sm min-w-max">
            <thead className="[&_tr]:border-b">
              <tr className="bg-gray-50/75 dark:bg-gray-800/50">
                <th className="h-11 px-4 align-middle text-muted-foreground text-center border-r border-gray-200 dark:border-white/20 bg-gray-50/75 dark:bg-gray-800/50 font-semibold uppercase text-xs tracking-wider" />
                {chartData.map((entry, index) => (
                  <th
                    className={`h-11 px-4 align-middle text-muted-foreground text-center border-gray-200 dark:border-gray-700 bg-gray-50/75 dark:bg-gray-800/50 whitespace-nowrap font-semibold uppercase text-xs tracking-wider ${
                      index === chartData.length - 1 ? "" : "border-r"
                    }`}
                    key={index}
                  >
                    {entry.tier} Households
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="[&_tr:last-child]:border-0">
              <tr className="border-b border-gray-200 dark:border-gray-700 transition-colors hover:bg-muted/50">
                <td className="px-4 py-3 text-left text-gray-700 dark:text-gray-300 border-r border-gray-200 dark:border-white/20 whitespace-nowrap font-semibold">
                  Household Count
                </td>
                {chartData.map((entry, index) => (
                  <td
                    className={`px-4 py-3 text-right text-gray-900 dark:text-white whitespace-nowrap ${
                      index === chartData.length - 1
                        ? ""
                        : "border-r border-gray-200 dark:border-white/20"
                    }`}
                    key={index}
                  >
                    {entry.householdCount.toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr className="border-b border-gray-200 dark:border-gray-700 transition-colors hover:bg-muted/50">
                <td className="px-4 py-3 text-left text-gray-700 dark:text-gray-300 border-r border-gray-200 dark:border-white/20 whitespace-nowrap font-semibold">
                  Total Sales
                </td>
                {chartData.map((entry, index) => (
                  <td
                    className={`px-4 py-3 text-right text-gray-900 dark:text-white whitespace-nowrap ${
                      index === chartData.length - 1
                        ? ""
                        : "border-r border-gray-200 dark:border-white/20"
                    }`}
                    key={index}
                  >
                    {formatCurrency(entry.totalSales)}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
